import './styles.scss';

import features from '../../../assets/draws/implementation-features.png';
import Button from '../../../components/button';

import { ReactComponent as ArrowLeftIcon } from '../../../assets/icons/arrow-left.svg';


export default function Process() {
    return (
        <div id="implementation" className="process mt-8 mb-3">
            <div className='headline'>
                <h1>Montamos sua plataforma com você em 45 dias!</h1>
                <h4 className='mb-1 mt-1'>
                    Já pensou em contar com a nossa equipe de designers, desenvolvedores e criação de produto para formatar uma
                    plataforma com a sua identidade...
                </h4>

                <h4 className='mb-1 mt-1'>
                    Aplique agora para uma implementação customizada!
                </h4>

                <Button.Large
                    className='mt-3'
                    text="Iniciar aplicação"
                    onClick={() => window.location.href = 'https://typebot.co/my-typebot-bg6rjxi'}
                    rightIcon={<ArrowLeftIcon />}
                />
            </div>


            <div className='features-container'>
                <img src={features} alt="Features" className='features' />

            </div>



        </div>
    );
}